<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-06 10:53:41
 * @LastEditTime: 2019-08-18 10:47:32
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container" v-loading='loading'>
          <div class="pageTitle">查看详情</div>
        <el-form   label-width="80px">
  <el-form-item label="订单状态:" style='color:red'>
           <span v-if="list.status == 0">未发货</span>
                                <span v-if="list.status == 1">已发货</span>
                                <span v-if="list.status == 2">部分发货</span>
                                <span v-if="list.status == 3">待付款</span>
                                <span v-if="list.status == 4">待审核</span>
                                <span v-if="list.status == 5">审核不通过</span>
                                <span v-if="list.status == 6">已完成</span>
                                <span v-if="list.status == 7">已取消</span>
  </el-form-item>
  <el-form-item label="订单号:">
  {{$route.query.id}}
  </el-form-item>
  <el-form-item label="订货经销商:">
   {{list.to_name}}
  </el-form-item>
  <el-form-item label="订货经销商级别:">
  {{list.to_level_name}}
  </el-form-item>
  <el-form-item label="手机:">
  {{list.to_mobile}}
   
  </el-form-item>
  <el-form-item label="收货地址:">
  {{list.to_address}}
  </el-form-item>
  <el-form-item label="支付方式:">
  {{pay_text[list.pay_type]}}
      
  </el-form-item>
  <el-form-item label="是否赠品:">
  {{list.isgift==1?'赠品':'非赠品'}}
    
  </el-form-item>
    <el-form-item label="订单留言:">
  {{list.order_notes}}
    
  </el-form-item>
   <el-form-item label="产品清单:">
        <el-table
      :data="list.products"
      border
      style="width: 100%">
      <el-table-column
        prop="product_sn"
        label="产品编号"
       >
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        >
      </el-table-column>
      <el-table-column
        prop="product_specs"
        label="产品规格">
      </el-table-column>
        <el-table-column
        prop="attribute_name"
        label="商品属性">
      </el-table-column>
          <el-table-column
        prop="last_price"
        label="订货价">
      </el-table-column>
       <el-table-column
        prop="stock_out_num"
        label="数量">
      </el-table-column>
    </el-table>
  </el-form-item>
<div style='margin:10px;text-align:right'>订单金额:<span style='color:red'>￥{{all}}</span>  </div>
     
 
<el-form-item label="发货仓库:">
  <!-- {{list.warehouse_name}} -->
     <el-select v-model="warehouse" placeholder="默认仓库">
         <el-option :label="v.warehouse_name" :value="v.warehouse_sn" v-for="(v,k) in warehousesList" :key='k'></el-option>
    </el-select>
  </el-form-item>
   <el-form-item label="">
    <el-radio-group v-model="status ">
      <el-radio :label="0" >审核通过</el-radio>
      <el-radio :label="5" >审核不通过</el-radio>
    </el-radio-group>
  </el-form-item >
          <div class="pageTitle" v-if='isCodeShow'>生成发货单（需要指定发货产品批次号及数量）</div>
    <div v-if='isCodeShow'> 
         <el-form-item label="">
    <el-button type="primary" @click='dialogVisible=!dialogVisible;type="add"' v-if='isCodeShow'>添加产品批次</el-button>
  </el-form-item>
    <el-form-item label="">
     <span class='red'>订单剩余数量：{{count}}</span>
  </el-form-item >
   <el-form-item label=""  >
          <el-table
      :data="batch"
      border
      style="width: 100%">
        <el-table-column
       
        prop="production_batch"
        label="生产批次号"
       >
      </el-table-column>
      <el-table-column
        prop="product_sn"
        label="产品编号"
       >
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="产品名称"
        >
      </el-table-column>
      <el-table-column
        prop="product_specs"
        label="产品规格">
      </el-table-column>
       <el-table-column
        prop="product_count"
        label="数量">
      </el-table-column>
          <el-table-column
        prop="product_count"
        label="操作">
        <template slot-scope="scope">
     <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
    <el-button type="text"  @click='del(scope.$index)'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-form-item>
    </div>

</el-form>

<div class="btns">
    <el-button type="primary"  @click='save'>保存</el-button>
    <el-button @click='back'>取消</el-button>

</div>

        <el-dialog
    title="添加产品批次"
    :visible.sync="dialogVisible"
    width="30%"
    >
       <el-form ref="form" v-model="form">
              <el-form-item label="出货产品:">
                  <el-row>
                      <el-col :span='4'><el-input v-model="form.product_sn"></el-input></el-col>
                      <el-col :span='1' style="text-align:center">-</el-col>
                      <el-col :span='6' style="margin-right:5px"><el-input v-model="form.product_name"></el-input></el-col>
    
                      <el-col :span='2'><el-button type="primary" @click='product=!product'>选择</el-button></el-col>

                  </el-row>
            </el-form-item>
              <el-form-item label="生产批次号:">
                <el-col :span='11'><el-input v-model="form.production_batch" readonly></el-input></el-col>
            </el-form-item>
              <el-form-item label="出货数量:">
                  <el-col :span='11'><el-input v-model="form.product_count"></el-input></el-col>
            </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confrimBatch">确 定</el-button>
    </span>
    </el-dialog>
    <product   v-if="product"
      v-on:handleClose=" product = false" 
      @pushData="getProduct"
      :product_sns='products'
   />
      <!--   -->
    </div>
</template>

<script>
import product from './product.vue'
import { setTimeout } from 'timers';
export default {
    data(){
        return{
            
            loading:false,
            list:[],
            warehouse:'',
            warehousesList:[],
            status:'',
            dialogVisible:false,
            form:{},
            product:false,
            products:[],
            batch:[]//生产批次号,
            ,isCodeShow:false,
            count:0,
            temp:0,
            max:0,
            type:'add',
            num:0,
            all:0,
            pay_text:['','线下支付','微信支付','微信扫码支付'],
        }
    },
    methods:{
         getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    
                    if(res.data.production_batch_on_off == 0){
                        this.isCodeShow = false;

                    }else if(res.data.production_batch_on_off == 1){
                        this.isCodeShow = true;
                        // this.getCount()
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        getDetail(){
            this.loading=true
            var url='/dealers.orders/'+this.$route.query.id
            this.$get('logistics',url).then(res=>{
                this.list=res.data
                this.status=this.list.status
                this.loading=false
                 this.all=res.data.total_price
                this.list.products.forEach(element => {
                    this.products.push(element.product_sn)
                    this.count+=Number(element.stock_out_num)
                
                });
                this.num=this.count
                this.batch=this.list.product_batchs
               
            })
        },
        getWarehouses(){
           this.$get('logistics','/warehouses.all').then(res=>{
                this.warehousesList=res.data
                  this.warehousesList.forEach(element => {
                    if(element.is_default==1){
                      this.warehouse=element.warehouse_sn
                    }
                });
           })
        },
           // 数组去重
        
        Unique(arr, name,name1) {
            var hash = {};
            return arr.reduce(function (item, next) {
      
                hash[next[name]]+hash[next[name1]] ? '' :( hash[next[name]]  = true )&& (hash[next[name1]] = true && item.push(next))
                
                return item;
            }, []);
            },
        back(){
            this.$router.go(-1)
        },
           // 获取商品
        getProduct(val){
              var temp=0,temp1=0
              this.list.products.forEach(element => {
                 if(element.product_sn==val.product_sn){
                   console.log(typeof element.stock_out_num,typeof temp)
                        temp+=Number(element.stock_out_num)
                 }
                  
                });
                 this.batch.forEach(element => {
                //   this.count= this.num-Number(element.product_count)
          
                 if(element.product_sn==val.product_sn){
                   console.log(typeof element.product_count,typeof temp1)

                        temp1+=Number(element.product_count)
                     
                 }
               });
                this.max=temp-temp1
                console.log(this.max,temp,temp1)
            this.form=val
        },
        // 确定 商品
        confrimBatch(){
          if(this.form.product_count==0){
                this.$message({
                                type: 'error',
                                message: '出货数量不能为0'
                            });
            return;
          }
            if(this.form.product_count>this.max){
                  this.$message({
                                type: 'error',
                                message: '超过最大值'
                            });
                return
            }
           
            
            this.dialogVisible = false
            this.batch.push(this.form)
               this.batch=this.Unique(this.batch,'product_sn','production_batch')
            this.Calcula()
            this.form={}
        },
      Calcula(){
           this.count=0
          if(this.batch.length==0){
               this.$set(this,'count',Number(this.num))
               return;
          }
          this.batch.forEach(element => {
          
                  this.$set(this,'count',Number(this.num)-Number(element.product_count))
              console.log(element,this.num,this.count)
          });
      },
        // 保存
        save(){
          if(this.status!='0'&&this.status!='5'){
              this.$message({
                                type: 'error',
                                message: '请选择审核状态'
                            });
            return;
          }
           
          if(this.status!=0&&this.warehouse==''){
               this.$message({
                                type: 'error',
                                message: '请选择仓库'
                            });
            return;
          }
            this.loading=true
            var product_count=[],production_batch=[],product_sn=[]
            this.batch.forEach(element => {
                    product_count.push(element.product_count)
                    production_batch.push(element.production_batch)
                    product_sn.push(element.product_sn)

            });
          
            var url='/dealers.orders/'+this.$route.query.id
            this.$put('logistics',url,{
            _method:'PUT',
            status:this.status,
            warehouse_sn:this.warehouse,
            product_sn:product_sn,
            production_batch:production_batch,
            product_count:product_count ,
            }).then(res=>{
            this.loading=false
            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                            setTimeout(()=>{
                                this.$router.go(-1)
                            },500)
            }).catch((error)=>{
              this.loading=false
                this.$message({
                                type: 'error',
                                message: error.message
                            });
            })
        },
        // 删除
        del(index){
                       this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(()=>{
            
            this.batch.splice(index,1)
            this.Calcula()
          
      })
        },
        edit(val){
            this.form=val
            this.dialogVisible=true
            this.temp=this.form.product_count
            this.Calcula()
        }
    },
    created(){
        this.getConfigInfo()
        this.getDetail()
        this.getWarehouses()
    },
    components:{
        product
    }

}
</script>


<style lang="scss" scoped>
/deep/.el-form-item{
    margin-bottom: 10px!important;
    .el-form-item__label{width: 150px!important;}
    .cell{
        height: 30px;
    }
} 
.btns{
    text-align: center;
}
.red{
    color:#f04635;
}
</style>
